<template>
  <v-container class="pa-0">
    <!-- DEBUG zastupcovia -->
    <v-card class="debug-card pa-2" v-if="debug">
      <h2>Zastupca data</h2>
      <v-card-actions>
        <v-btn
          v-for="(v, i) in varianty"
          :key="i"
          class="btn-secondary"
          icon
          @click="variantDebugIndex = i"
          >{{ i }}</v-btn
        >
      </v-card-actions>
      <v-card-text>
        <table v-if="varianty">
          <tr v-for="[key, value] in getVariantyDebugEntries()" :key="key">
            <th>{{ key }}:</th>
            <td class="pl-2">{{ value }}</td>
          </tr>
        </table>
      </v-card-text>
    </v-card>

    <v-dialog
      v-model="showScoring"
      overlay-color="#000"
      overlay-opacity="0.66"
      persistent
      eager
      max-width="900"
    >
      <v-card>
        <v-card-title class="d-flex justify-space-between"> Scoring </v-card-title>
        <v-card-text>
          <scoring-parameters
            ref="scoring"
            :scoringData="scoringData"
            :variant="scoringVariant"
          ></scoring-parameters>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="btn-primary" @click="saveScoring()"> Uložiť </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-card class="card">
      <div v-if="!isMobile" class="d-flex">
        <div class="mr-auto">
          <div class="d-flex align-center" style="max-width: 740px">
            <h2>{{ predmet.nazov_predmetu }}</h2>
            <v-icon v-if="showSelectedStateIcon" class="sumar-predmet-check-icon ml-2">
              mdi-check
            </v-icon>
          </div>
          <p class="f16 c-grayscale-100 mt-1">
            {{ predmet.typ_predmetu }}
          </p>
        </div>
        <div v-if="predmet.stav != null">
          <status custom :color="predmet.farba" large>
            {{ predmet.stav }}
          </status>
        </div>
        <div class="f18 ml-3">
          <span class="f12 gs100 d-block mb-n4px" style="white-space: nowrap; text-align: end"
            >Kúpna cena</span
          >
          <b class="d-block text-right" style="white-space: nowrap">{{
            predmet.oc_s_dph ? predmet.oc_s_dph.toEurString() : ''
          }}</b>
          <template v-if="predmet.cena_car_catalog && jeDealer">
            <span class="f16 gs100 d-block mb-n8px" style="white-space: nowrap">Ocenenie: </span>
            <b class="text-right d-block">{{
              predmet.cena_car_catalog ? predmet.cena_car_catalog.toEurString() : ''
            }}</b>
          </template>
        </div>
        <v-tooltip
          top
          :close-delay="0"
          :open-delay="200"
          v-if="getMenuItem('duplikovat').is_visible"
        >
          <template v-slot:activator="{ on }">
            <v-btn
              class="btn-secondary btn-icon ml-10"
              v-on="on"
              @click="duplikujPredmet(predmet.cislo_predmetu)"
              :disabled="getMenuItem('duplikovat').is_enabled === 0"
              ><v-icon class="f20 material-icons-outlined">$copy</v-icon></v-btn
            >
          </template>
          <span>Duplikovať</span>
        </v-tooltip>

        <v-tooltip top :close-delay="0" :open-delay="200" v-if="getMenuItem('edit').is_visible">
          <template v-slot:activator="{ on }">
            <v-btn
              class="btn-secondary btn-icon ml-3"
              v-on="on"
              :disabled="
                getMenuItem('edit').is_enabled === 0 || pripad == null || pripad.newId == null
              "
              @click="editovaniePredmetu()"
              ><v-icon class="f20">$edit</v-icon></v-btn
            >
          </template>
          <span>Editovať</span>
        </v-tooltip>
        <v-tooltip top :close-delay="0" :open-delay="200" v-if="getMenuItem('zmazat').is_visible">
          <template v-slot:activator="{ on }">
            <v-btn
              class="btn-secondary btn-icon ml-3"
              v-on="on"
              :disabled="getMenuItem('zmazat').is_enabled === 0"
              @click="openDeleteDialog(predmet.cislo_predmetu)"
              ><v-icon class="f20">$trash</v-icon></v-btn
            >
          </template>
          <span>Zmazať</span>
        </v-tooltip>
        <v-btn @click="() => $emit('setShowPredmet', !show)" icon class="btn-icon ml-3">
          <v-icon :class="{ 'rotate-180': show }">mdi-chevron-down</v-icon>
        </v-btn>
      </div>
      <div v-else class="d-flex flex-column">
        <div>
          <v-btn
            v-if="getMenuItem('duplikovat').is_visible"
            class="btn-secondary btn-icon"
            @click="duplikujPredmet(predmet.cislo_predmetu)"
            :disabled="getMenuItem('duplikovat').is_enabled === 0"
            ><v-icon class="f20 material-icons-outlined">$copy</v-icon></v-btn
          >
          <v-btn
            v-if="getMenuItem('edit').is_visible"
            class="btn-secondary btn-icon ml-2"
            :disabled="
              getMenuItem('edit').is_enabled === 0 || pripad == null || pripad.newId == null
            "
            :to="`/obchodny-pripad/${pripad.newId}?cislo_predmetu=${predmet.cislo_predmetu}&step=2`"
            ><v-icon class="f20">$edit</v-icon></v-btn
          >
          <v-btn
            v-if="getMenuItem('zmazat').is_visible"
            class="btn-secondary btn-icon ml-2"
            :disabled="getMenuItem('zmazat').is_enabled === 0"
            @click="openDeleteDialog(predmet.cislo_predmetu)"
            ><v-icon class="f20">$trash</v-icon></v-btn
          >
          <v-btn @click="() => $emit('setShowPredmet', !show)" icon class="btn-icon right">
            <v-icon :class="{ 'rotate-180': show }">mdi-chevron-down</v-icon>
          </v-btn>
        </div>
        <div class="mt-6 mb-2">
          <div class="d-flex align-center mb-2" style="max-width: 740px">
            <h2 class="mb-0">{{ predmet.nazov_predmetu }}</h2>
            <v-icon v-if="showSelectedStateIcon" class="sumar-predmet-check-icon ml-2">
              mdi-check
            </v-icon>
          </div>
          <span class="f16 c-grayscale-100">
            {{ predmet.typ_predmetu }}
          </span>
        </div>
        <div v-if="predmet.stav != null">
          <status custom :color="predmet.farba" large>
            {{ predmet.stav }}
          </status>
        </div>
        <div class="f18">
          <span class="f12 gs100 d-block mb-n4px" style="white-space: nowrap">Kúpna cena</span>
          <b class="d-block" style="white-space: nowrap">{{
            predmet.oc_s_dph ? predmet.oc_s_dph.toEurString() : ''
          }}</b>
          <template v-if="predmet.cena_car_catalog && jeDealer">
            <span class="f16 gs100 d-block mb-n8px" style="white-space: nowrap">Ocenenie: </span>
            <b class="d-block">{{
              predmet.cena_car_catalog ? predmet.cena_car_catalog.toEurString() : ''
            }}</b>
          </template>
        </div>
      </div>
      <v-expand-transition>
        <div v-show="show">
          <div class="mb-16px mt-16px w60" v-if="stavPonuky">
            <span class="gs100 f18" v-html="stavPonuky"></span>
          </div>
          <v-form ref="form" class="mb-16px" v-if="showEmailSpoludlznika" @submit.native.prevent>
            <v-row no-gutters style="gap: 30px">
              <v-col cols="4" class="pa-0">
                <v-text-field
                  v-model="emailSpoludlznik"
                  :label="'E-mail spolužiadateľa'"
                  class="dynamic-input-control required"
                  :rules="[required, email]"
                  outlined
                  required
                  @keydown.enter.native.prevent="odoslatRegistraciuSpoludlznikovy"
                ></v-text-field>
              </v-col>
              <v-col cols="auto" class="pa-0">
                <v-btn
                  class="btn-secondary f16 mt-1"
                  style="height: auto !important; padding: 14.5px 28px"
                  @click="odoslatRegistraciuSpoludlznikovy"
                  >Odoslať e-mail</v-btn
                >
              </v-col>
            </v-row>
          </v-form>
          <div class="mb-16px">
            <v-card
              elevation="0"
              class="card-item pa-20px mb-24px"
              v-for="(zmluva, i) in zmluvy"
              :key="i"
            >
              <div class="d-flex flex-row">
                <text-group
                  class="flex-grow-1 mr-20px"
                  utext="Číslo zmluvy"
                  :btext="zmluva.cislo_lz"
                  smallHeader
                />
                <div
                  v-if="zmluva.poznamka != null || zmluva.poznamka_2 != null"
                  class="d-flex pt-6px ml-auto pr-3"
                  style="z-index: 2"
                >
                  <a
                    class="bold sumar-item-arrow-color"
                    @click="openSuhlasDialog(zmluva)"
                    style="font-size: 15px; white-space: nowrap"
                  >
                    Súhlas s podmienkami
                    <v-icon>mdi-chevron-right</v-icon>
                  </a>
                </div>
                <text-group
                  utext="Akontácia"
                  class="mr-20px"
                  :btext="zmluva.akont_perc.toPercentString(2)"
                  smallHeader
                />
                <text-group
                  class="mr-20px"
                  utext="Dĺžka splácania"
                  :btext="zmluva.tenor"
                  smallHeader
                />
                <text-group
                  class="mr-20px"
                  utext="Splátka"
                  :btext="zmluva.splatka.toEurString()"
                  smallHeader
                />
                <text-group class="mr-20px" utext="Perióda" :btext="zmluva.perioda" smallHeader />
                <!-- <text-group
                    v-if="zmluva.zost_hodnota_perc"
                    utext="Zostatková hodnota"
                    class="mr-20px"
                    :btext="zmluva.zost_hodnota_perc.toPercentString(2)"
                    smallHeader
                  />
                  <text-group
                    v-if="zmluva.zv_spl_koniec_perc"
                    utext="Posledná zvýšená splátka"
                    class="mr-20px"
                    :btext="zmluva.zv_spl_koniec_perc.toPercentString(2)"
                    smallHeader
                  /> -->
                <div class="mr-20px">
                  <status custom :color="zmluva.farba" large>
                    {{ zmluva.stav }}
                    <template v-if="jeDealer && (zmluva.iur)">
                      <v-tooltip top :close-delay="0" :open-delay="200">
                        <template v-slot:activator="{ on }">
                          <v-icon
                            v-on="on"
                            class="btn-help poznamka-icon"
                            @click="nastavPoznamkuAndIur(zmluva,true)"
                          >
                            mdi-alert-circle
                          </v-icon>
                        </template>
                        <span>Poznámka</span>
                      </v-tooltip>
                    </template>
                  </status>
                </div>
                <!-- <v-tooltip
                    top
                    :close-delay="0"
                    :open-delay="200"
                    v-if="pravoNaAdresnuPonuku && jeDealer"
                  >
                    <template v-slot:activator="{ on }">
                      <v-btn
                        small
                        class="btn-primary btn-icon mr-20px"
                        v-on="on"
                        @click="openPonuknuteVariantyDialog(zmluva)"
                        :disabled="!zmluva.ponukni_varianty"
                        ><v-icon :size="17" class="material-icons-outlined">help</v-icon></v-btn
                      >
                    </template>
                    <span>Schválené varianty</span>
                  </v-tooltip> -->
                <v-btn
                  class="btn-primary radius-4 f14 mr-20px"
                  @click="openPripravZmluvuDialog(zmluva)"
                  :disabled="!zmluva.enabled"
                  small
                  >Priprav zmluvu</v-btn
                >
              </div>
            </v-card>
          </div>
          <div>
            <template v-if="ponuknuteVarianty != [] && ponuknuteVarianty.length > 0">
              <span class="f18 gs100"
                >Vami zvolená ponuka nemôže byť schválená. Ponúkame vám nasledujúce možnosti:</span
              >
              <v-item-group :multiple="false" class="py-12px">
                <v-row>
                  <v-col
                    v-for="(variant, i) in ponuknuteVarianty"
                    :key="i"
                    :cols="true ? 12 : 3"
                    class="pa-12px"
                  >
                    <v-item :value="variant">
                      <sumar-produkt-variant
                        style="cursor: auto"
                        :row="true"
                        :value="variant"
                        @odoslatClick="vyberVariant(variant)"
                        :pravoNaAdresnuPonuku="pravoNaAdresnuPonuku"
                        @reloadPonuknuteVarianty="nacitajZmluvy"
                      ></sumar-produkt-variant>
                    </v-item>
                  </v-col>
                </v-row>
              </v-item-group>
            </template>
            <span class="f18">Ponuky na schválenie</span>
            <v-item-group :multiple="false" :value="selectedVariant" class="py-12px">
              <v-row>
                <v-col
                  v-for="(variant, i) in varianty"
                  :key="i"
                  sm="12"
                  :md="row_variant ? 12 : 3"
                  class="pa-12px"
                >
                  <v-item :value="variant">
                    <sumar-produkt-variant
                      :row="row_variant"
                      :value="variant"
                      :odoslane="false"
                      @nastavPoznamku="value => nastavPoznamkuAndIur(value)"
                      @select="val => selectVariant(val)"
                      @openPorovnanieBalikovDialog="openPorovnanieBalikovDialog"
                      :pravoNaAdresnuPonuku="pravoNaAdresnuPonuku"
                      :jeDealer="jeDealer"
                      :jePrihlaseny="jePrihlaseny"
                      :formaPodnikania="formaPodnikania"
                    ></sumar-produkt-variant>
                  </v-item>
                </v-col>
              </v-row>
            </v-item-group>
          </div>

          <!-- POISTENIE -->
          <v-expansion-panels
            class="wizard-expansion-panels"
            :class="{ 'mt-10px': !isMobile }"
            accordion
            multiple
            flat
            v-model="panel"
          >
            <v-expansion-panel class="mb-20px">
              <v-expansion-panel-header class="pa-0"> Poistenie </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row :no-gutters="isMobile">
                  <v-col cols="12">
                    <v-row v-if="!isMobile" class="mt-20px'">
                      <v-col cols="3" class="py-0" v-show="poistenie_kasko"> Havarijné poistenie </v-col>
                      <v-col cols="3" class="py-0" v-show="poistenie_pzp"> Povinné zmluvné poistenie </v-col>
                      <v-col cols="3" class="py-0" v-show="poistenie_fs"> Poistenie finančnej straty </v-col>
                      <v-col cols="3" class="py-0" v-show="poistenie_olfs_kasko"> Operatívny leasing </v-col>
                    </v-row>
                    <v-row class="mb-10px" :class="{ 'mt-10px': !isMobile }" :no-gutters="isMobile">
                      <v-col v-if="isMobile" cols="12" class="bold my-4" v-show="poistenie_kasko">
                        Havarijné poistenie
                      </v-col>
                      <v-col md="3" sm="12" v-show="poistenie_kasko">
                        <poistenie-card
                          v-if="poistenie_kasko"
                          :value="poistenie_kasko"
                          data-id="liw_filip__wiz_poistenie__cb_poistenie_kasko"
                          :newId="pripad.newId"
                          :cisloPredmetu="predmet.cislo_predmetu"
                          :sumar="1"
                        />
                      </v-col>
                      <v-col v-if="isMobile" cols="12" class="bold my-4" v-show="poistenie_pzp">
                        Povinné zmluvné poistenie
                      </v-col>
                      <v-col md="3" sm="12" v-show="poistenie_pzp">
                        <poistenie-card
                          v-if="poistenie_pzp"
                          :value="poistenie_pzp"
                          data-id="liw_filip__wiz_poistenie__cb_poistenie_pzp"
                          :newId="pripad.newId"
                          :cisloPredmetu="predmet.cislo_predmetu"
                          :sumar="1"
                        />
                      </v-col>
                      <v-col v-if="isMobile" cols="12" class="bold my-4" v-show="poistenie_fs">
                        Poistenie finančnej straty
                      </v-col>
                      <v-col md="3" sm="12" v-show="poistenie_fs">
                        <poistenie-card
                          v-if="poistenie_fs"
                          :value="poistenie_fs"
                          data-id="liw_filip__wiz_poistenie__cb_poistenie_fs"
                          :newId="pripad.newId"
                          :cisloPredmetu="predmet.cislo_predmetu"
                          :sumar="1"
                        />
                      </v-col>
                      <v-col v-if="isMobile" cols="12" class="bold my-4" v-show="poistenie_olfs_kasko">
                        Operatívny leasing
                      </v-col>
                      <v-col md="3" sm="12" v-show="poistenie_olfs_kasko">
                        <poistenie-card
                          v-if="poistenie_olfs_kasko"
                          :value="poistenie_olfs_kasko"
                          data-id="liw_filip__wiz_poistenie__cb_poistenie_olfs"
                          :newId="pripad.newId"
                          :cisloPredmetu="predmet.cislo_predmetu"
                          :sumar="1"
                          isOlfs
                        />
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header class="pa-0">
                Informácie o predmete
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row :no-gutters="isMobile">
                  <v-col xs="12" sm="12" md="9">
                    <v-row
                      :class="{ 'mt-20px': !isMobile, 'd-flex flex-column mt-4': isMobile }"
                      no-gutters
                    >
                      <template v-if="predmet.je_auto === 1">
                        <v-col
                          v-for="header in infoPredmetHeaders"
                          :key="header.value"
                          xs="12"
                          sm="12"
                          md="4"
                          :class="{ 'pb-2': !isMobile, 'pb-3': isMobile }"
                        >
                          <v-row no-gutters>
                            <span class="f12 gs100">{{ header.text }}</span>
                          </v-row>
                          <v-row
                            v-if="header.value != 'dat_reg'"
                            no-gutters
                            :class="{
                              bold: header.text != 'VIN',
                              'pb-6': predmet[header.value] == null,
                            }"
                          >
                            <span class="f16"
                              >{{
                                predmet[header.value] == null
                                  ? ''
                                  : header.suffix
                                  ? predmet[header.value].formatSuffix(header.suffix)
                                  : predmet[header.value]
                              }}
                            </span>
                          </v-row>
                          <v-row v-else no-gutters>
                            <span class="f16 bold"
                              >{{ predmet.datum_1_reg ? predmet.datum_1_reg.formatDate() : '' }}
                            </span>
                          </v-row>
                        </v-col>
                      </template>
                      <template v-else>
                        <v-col
                          v-for="header in infoStrojHeaders"
                          :key="header.value"
                          xs="12"
                          sm="12"
                          md="4"
                          :class="{ 'pb-2': !isMobile, 'pb-3': isMobile }"
                        >
                          <v-row no-gutters>
                            <span class="f12 gs100">{{ header.text }}</span>
                          </v-row>
                          <v-row
                            no-gutters
                            :class="{
                              bold: header.text != 'VIN',
                              'pb-6': predmet[header.value] == null,
                            }"
                          >
                            <span class="f16"
                              >{{
                                predmet[header.value] == null
                                  ? ''
                                  : header.suffix
                                  ? predmet[header.value].formatSuffix(header.suffix)
                                  : predmet[header.value]
                              }}
                            </span>
                          </v-row>
                        </v-col>
                      </template>
                      <v-col xs="12" sm="12" md="4" :class="{ 'pb-3': isMobile }">
                        <v-row no-gutters :class="{ 'pb-6': predmet.obstaravacia_cena == null }">
                          <span class="f12 gs100">{{
                            jeDealer ? 'Obstarávacia cena' : 'Kúpna cena'
                          }}</span>
                        </v-row>
                        <v-row no-gutters class="bold">
                          <span class="f16"
                            >{{
                              predmet.obstaravacia_cena
                                ? predmet.obstaravacia_cena.toEurString()
                                : ''
                            }}
                          </span>
                        </v-row>
                      </v-col>
                      <v-col xs="12" sm="12" md="4" :class="{ 'pb-3': isMobile }">
                        <v-row no-gutters :class="{ 'pb-6': predmet.cennikova_cena_s_dph == null }">
                          <span class="f12 gs100">Cenníková cena</span>
                        </v-row>
                        <v-row no-gutters class="bold">
                          <span class="f16"
                            >{{
                              predmet.cennikova_cena_s_dph
                                ? predmet.cennikova_cena_s_dph.toEurString()
                                : ''
                            }}
                          </span>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel v-if="jeDealer">
              <v-expansion-panel-header class="pa-0"> Poznámka </v-expansion-panel-header>
              <v-expansion-panel-content :class="{ 'pt-5': !isMobile, 'pt-4': isMobile }">
                <v-row :no-gutters="isMobile" :class="{ 'd-flex flex-column': isMobile }">
                  <v-col xs="12" sm="12" md="6">
                    <v-row no-gutters>
                      <v-col>
                        <v-textarea
                          class="dynamic-input-control"
                          ref="textareaPoznamka"
                          outlined
                          v-model="poznamkaPredmetu.message"
                          :rules="poznamkaPredmetu.rules"
                          dense
                          placeholder="Napíšte poznámku"
                          counter="200"
                        ></v-textarea>
                      </v-col>
                    </v-row>
                    <v-row :no-gutters="isMobile">
                      <v-col :class="{ 'pt-4': isMobile }">
                        <v-btn
                          @click="savePoznamkaPredmetu"
                          class="btn-primary"
                          :style="isMobile ? { width: '100%' } : {}"
                          :disabled="!poznamkaPredmetuValid"
                        >
                          Uložiť
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col xs="12" sm="12" md="6">
                    <v-row
                      :no-gutters="isMobile"
                      v-for="historiaPoznamka in historiaPoznamokPredmetu"
                      :key="historiaPoznamka.value_member"
                      class=""
                      :class="{ 'pb-15px': !isMobile }"
                    >
                      <v-col :class="{ 'pt-4': isMobile }">
                        <h4>
                          {{ historiaPoznamka.modifikoval }} -
                          {{ historiaPoznamka.modifikovane.formatDateTime() }}
                        </h4>
                        <span style="white-space: pre-line">
                          {{ historiaPoznamka.display_member }}
                        </span>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
      </v-expand-transition>
    </v-card>

    <!-- DIALOG -->
    <!-- <v-dialog
      :value="ponuknuteVariantyDialogOpen"
      overlay-color="#000"
      overlay-opacity="0.66"
      :persistent="true"
      width="800"
    >
      <v-card>
        <v-card-title class="text-center">
          <div class="w100">
            <v-icon :size="32" class="primary500">help</v-icon>
          </div>
        </v-card-title>
        <v-card-text>
          <div class="white100 bold f16 text-center mb-15px">
            Vami zvolená ponuka nemôže byť schválená
          </div>
          <div class="white500 f16 text-center mb-10px">
            Vami vybratý variant bol zamietnutý ale ponúkame Vám nasledujúce možnosti:
          </div>
          <v-card
            elevation="0"
            class="card-item pa-20px mb-24px"
            v-for="(variant, index) in ponuknuteVarianty"
            :key="index"
          >
            <div class="d-flex flex-row align-center">
              <text-group
                class="w180px mr-20px"
                :utext="variant.druh_financovania"
                :btext="variant.nazov_produktu"
                smallHeader
              />
              <text-group
                utext="Akontácia"
                class="w80px mr-20px"
                :btext="variant.akontacia_perc.toPercentString(2)"
                smallHeader
              />
              <text-group class="w50px mr-20px" utext="Tenor" :btext="variant.tenor" smallHeader />
              <text-group
                class="w100px mr-20px"
                utext="Splátka"
                :btext="variant.splatka.toEurString()"
                smallHeader
              />
              <text-group
                class="w80px mr-20px"
                utext="Perióda"
                :btext="variant.perioda_text"
                smallHeader
              />
              <v-btn class="btn-primary w120px radius-4 f14" @click="vyberVariant(variant)" small>
                Vyber variant
              </v-btn>
            </div>
          </v-card>
          <div class="white500 f16 text-center">
            Alebo si nakonfigurujte novú ponuku v sekcii
            <a
            :disabled="pripad == null || pripad.newId == null"
            :to="`/obchodny-pripad/${
              this.pripad.newId
            }?cislo_predmetu=${this.pripad.cisloPredmetu}&kalkulacia=${1}`"
              >kalkulácia</a
            >
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="ml-5 bold gs100" text @click="variantyDialogCloseClick()"> Zavrieť </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> -->
    <v-dialog
      v-model="poznamka.open"
      overlay-color="#000"
      overlay-opacity="0.66"
      persistent
      eager
      max-width="1000"
    >
      <v-card>
        <v-card-title class="d-flex justify-space-between">
          <span class="gs100 f16">Poznámka</span>
          <v-btn icon @click="poznamka.open = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="f16 white100">
          <span style="white-space: pre-line; margin: 0px 16px">
            {{ poznamka.text }}
          </span>
          <v-divider
            style="margin-top: 16px"
            v-if="poznamka.text != null && iur.items.length > 0"
          ></v-divider>
          <v-data-table
            v-if="iur.items.length > 0"
            :headers="iur.headers"
            :items="iur.items"
            hide-default-footer
            disable-pagination
            disable-sort
            dense
            class="standard-table"
          >
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="btn-secondary" @click="poznamka.open = false"> Zavrieť </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="podpisovanieDokumentov"
      overlay-color="#000"
      overlay-opacity="0.66"
      persistent
      eager
      max-width="500"
    >
      <v-card>
        <v-card-title class="d-flex justify-space-between">
          <span class="gs100 f16">Podpisovanie dokumentov</span>
          <v-btn icon @click="podpisovanieDokumentov = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="f16">
          Zmluvu za spoločnosť {{ currentProfileName }} bude podpisovať:
          <br />
          <span class="gs200">
            (prosím vyberte prosím zo zoznamu podpisujúcich opravených konať za spoločnosť)
          </span>
          <v-form ref="podpisovanieForm" @submit.prevent>
            <dynamic-combo
              :rules="[podpisovanie]"
              label="Zoznam oprávnených osôb"
              multiple
              v-model="osobyNaPodisanie"
              :items="opravneneOsoby"
              displayMember="menoApriezvisko"
              valueMember="id_zastupcu"
              :cache="false"
              class="mr-16px mt-12px"
            >
            </dynamic-combo>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="btn-primary" @click="podpisatDokumenty"> Pokračovať </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="doplnenieIbanDialog"
      overlay-color="#000"
      overlay-opacity="0.66"
      persistent
      eager
      max-width="500"
    >
      <v-card>
        <v-card-title class="d-flex justify-space-between">
          <span class="gs100 f16">Doplňujúce informácie</span>
          <v-btn icon @click="doplnenieIbanDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="f16">
          <v-form ref="checkIbanForm" @submit.prevent>
            <v-text-field
              v-model="iban"
              label="IBAN"
              class="dynamic-input-control required mt-20px mr-16px"
              :rules="[required]"
              outlined
              :error-messages="ibanErrorText"
              @focusout="
                    v => checkCorrectnessIban(this.iban)
                  "
              required
               @keyup.enter="aktualizovatIban"
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="btn-primary" @click="aktualizovatIban"> Pokračovať </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="doplnenieVinDialog"
      overlay-color="#000"
      overlay-opacity="0.66"
      persistent
      eager
      max-width="500"
    >
      <v-card>
        <v-card-title class="d-flex justify-space-between">
          <span class="gs100 f16">Doplňujúce informácie</span>
          <v-btn icon @click="doplnenieVinDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="f16">
          Pre pokračovanie prosím doplňte nasledujúce informácie.
          <br />
          <v-form ref="checkVinForm" @submit.prevent>
            <v-text-field
              v-model="vin"
              :label="'Výrobné číslo' + (jeAutomobil ? ' (VIN)' : '')"
              class="dynamic-input-control required mt-20px mr-16px"
              :rules="[required, vinRule]"
              outlined
              :error-messages="vinErrorText"
              required
               @keyup.enter="aktualizovatVin"
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="btn-secondary" @click="prekalkulovatPonuku" v-if="prekalkulovat">
            Prekalkulovať ponuku
          </v-btn>
          <v-btn class="btn-primary" @click="aktualizovatVin"> Pokračovať </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="doplnenieInformaciiDialog"
      overlay-color="#000"
      overlay-opacity="0.66"
      persistent
      eager
      max-width="500"
    >
      <v-card>
        <v-card-title class="d-flex justify-space-between">
          <span class="gs100 f16">Doplňujúce informácie</span>
          <v-btn icon @click="doplnenieInformaciiDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="f16">
          <v-checkbox
            style="white-space: nowrap; margin-top: 0px"
            v-bind:class="{
              dynamic_check_box: true,
            }"
            label="Som platca DPH "
            v-model="doplnujuceInformacie.platcaDph"
            hide-details
            @change="onChangePlatcaDPH"
          />
          <br />
          <v-form ref="doplnujuceInformacieForm" @submit.prevent>
            <v-text-field
              v-model="doplnujuceInformacie.ic_dph"
              label="IČ DPH"
              class="dynamic-input-control required mt-20px mr-16px"
              :rules="doplnujuceInformacie.platcaDph ? [required] : []"
              outlined
              :disabled="!doplnujuceInformacie.platcaDph"
              @input="
                v =>
                  (doplnujuceInformacie.dic =
                    !!doplnujuceInformacie.ic_dph && doplnujuceInformacie.ic_dph.includes('SK')
                      ? doplnujuceInformacie.ic_dph.replace('SK', '')
                      : doplnujuceInformacie.dic)
              "
              required
            ></v-text-field>
            <v-text-field
              v-model="doplnujuceInformacie.dic"
              label="DIČ"
              class="dynamic-input-control required mt-20px mr-16px"
              :rules="[required]"
              outlined
              required
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="btn-primary" @click="setIc()"> Pokračovať </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="sposobPodpisaniaDialog"
      overlay-color="#000"
      overlay-opacity="0.66"
      persistent
      eager
      max-width="500"
    >
      <v-card>
        <v-card-title class="d-flex justify-space-between">
          <span class="gs100 f16">Pripraviť zmluvu</span>
          <v-btn icon @click="sposobPodpisaniaDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="f16 pb-0px">
          <v-radio-group v-model="sposobPodpisania">
            <template v-slot:label>
              <div>Vyberte si spôsob podpísania zmluvy</div>
            </template>
            <template v-for="item in sposobyPodpisania">
              <v-radio
                v-if="item.valueMember < 3 || (item.valueMember == 3 && jeDealer)"
                :key="item.valueMember"
                :label="item.displayMember"
                :value="item.valueMember"
                class=""
              ></v-radio>
            </template>
          </v-radio-group>
          <template v-if="sposobPodpisania == 2">
            <v-form ref="vyberPobocky" @submit.prevent>
              <dynamic-combo
                :rules="[required]"
                label="Zoznam pobočiek"
                v-model="pobocka"
                :items="pobocky"
                displayMember="adresa"
                return-object
                :cache="false"
                required
                class="mr-16px"
              >
              </dynamic-combo>
              <v-divider class="mb-16px"></v-divider>
              <span>Pri podpisovaní zmluvy na pobočke si môžete vybrať obchodníka</span>
              <dynamic-combo
                class="mt-16px mr-16px"
                :disabled="!obchodnikEnabled"
                label="Zoznam obchodníkov"
                v-model="obchodnik"
                :items="obchodnici"
                displayMember="meno"
                return-object
                :cache="false"
              >
              </dynamic-combo>
            </v-form>
          </template>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="btn-primary" @click="setSposobPodpisu"> Potvrdiť </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      :value="vins.items.length > 0"
      overlay-color="#000"
      overlay-opacity="0.66"
      persistent
      max-width="1000"
    >
      <v-card class="dialog-card">
        <v-card-title class="d-flex justify-space-between">
          <h1>Vyberte si verziu modelu</h1>
          <v-btn icon @click="vins.items = []">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-data-table
            :headers="vins.headers"
            :items="vins.items"
            disable-pagination
            hide-default-footer
            @click:row="selectVerziaModelu"
            class="standard-table row-pointer"
          >
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="porovnanieBalikovDialog" max-width="896">
      <v-card class="dialog-card">
        <v-card-title class="d-flex justify-space-between dialog-title-close">
          <span> Porovnanie balíkov </span>
          <v-btn icon @click="closePorovnanieBalikov()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="gs100">
          <v-row no-gutters class="mx-0">
            <v-col cols="12">
              <v-row class="mx-0">
                <v-col v-for="(item,index) in porovnanieBalikov" :key="index" cols="12" :md="4">
                  <v-row no-gutters style="gap:8px">
                    <v-col cols="12" class="bold">
                      <span class="f18 white100">
                        {{ item[0].display_member }}
                      </span>
                    </v-col>
                    <v-col cols="12" v-for="(row,rowIndex) in item" :key="rowIndex">
                      <v-icon class="btn-help porovnanie-balikov-icon"
                        size="16px">
                        $check_circle
                      </v-icon>
                      <span>
                        {{ row.sluzba }}
                      </span>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <message-box
      :yes-no="warningDialog.yesNo"
      :title="warningDialog.title"
      :text="warningDialog.text"
      v-model="warningDialog.open"
      :action="warningDialog.action"
      :hide-cancel="warningDialog.hideCancel"
      :zIndex="warningDialog.zIndex"
    />
    <v-overlay color="#000" opacity="0.40" :value="loading.open" :z-index="loading.zIndex">
      <v-card width="500" class="text-center mt-n100px card">
        <v-progress-circular class="mb-20px" indeterminate color="primary" :size="25" :width="2" />
        <text-group
          invert
          large
          :utext="loading.utext"
          :btext="loading.btext"
          :gap="20"
        ></text-group>
      </v-card>
    </v-overlay>
  </v-container>
</template>
<script>
import SumarProduktVariant from './SumarProduktVariant';
import TextBox from '../basic/TextBox';
import MessageBox from '../basic/MessageBox';
import TextGroup from '../basic/TextGroup.vue';
import Status from '../basic/Status.vue';
import protectedAxios from '../../auth/axios';
import { mapState, mapGetters, mapMutations } from 'vuex';
import PoistenieCard from '../poistenie/PoistenieCard.vue';
import { pripadLinkMixin } from '../../mixins/pripadLinkMixin';
import { globalMixin } from '../../mixins/globalMixin';
import ScoringParameters from '../sumar/ScoringParameters.vue';
import { eventBus } from '../../main.js';
import { cacheMixin } from '../../mixins/cacheMixin';
import DynamicCombo from '../basic/DynamicCombo.vue';

export default {
  mixins: [pripadLinkMixin, cacheMixin, globalMixin],
  components: {
    SumarProduktVariant,
    TextBox,
    PoistenieCard,
    TextGroup,
    Status,
    ScoringParameters,
    MessageBox,
    DynamicCombo,
  },
  props: {
    predmet: Object,
    pravoNaAdresnuPonuku: Boolean,
    show: Boolean,
    formaPodnikania: Object,
  },
  computed: {
    ...mapState(['pripad']),
    ...mapGetters(['debug', 'jeDealer', 'jePrihlaseny', 'isMobile', 'odoslatNaSchvalenieRequest']),
    ...mapGetters('auth', ['currentProfileName']),
    showSelectedStateIcon() {
      return this.selectedVariant != null || this.zmluvy.length > 0;
    },
    stavPonuky(zmluva) {
      if (zmluva) {
        if (this.showEmailSpoludlznika) {
          return 'Vami zvolená ponuka môže byť schválená po pridaní spolužiadateľa.<br/><br/> Pred odoslaním ponuky na schválenie je potrebné, aby mal spolužiadateľ vytvorený účet a overenú totožnosť. Spolužiadateľovi príde e-mailom link na registráciu.';
        } else {
          switch (zmluva.farba) {
            case 'red':
              return 'Ponuka bola zamietnutá.';
            case 'orange':
              return 'Ponuka prechádza procesom schvaľovania. O výsledku vás budeme informovať e-mailom.';
            case 'green':
              return 'Ponuka bola schválená. Môžete prejsť na vytvorenie a podpis zmluvy.';
          }
        }
      }
      return null;
    },
  },
  watch: {
    'poznamkaPredmetu.message'() {
      this.poznamkaPredmetuValid = this.$refs.textareaPoznamka
        ? this.$refs.textareaPoznamka.validate()
        : true;
    },
    async pobocka() {
      if (this.pobocka) {
        await this.getZoznamObchodnikov(this.pobocka);
      } else {
        this.obchodnikEnabled = false;
      }
    },
    show() {
      if (this.show) this.getMenu();
    },
    async sposobPodpisania() {
      this.pobocka = null;
      this.obchodnik = null;
      if (this.sposobPodpisania == 2) {
        await this.getZoznamPobociek();
      }
    },
    isLoaded() {
      this.$emit('loaded');
    },
    selectedVariant() {
      this.$emit('changeVariant');
    },
  },
  data: () => ({
    isLoaded: false,
    panel: [0],
    varianty: [],
    poistenie_kasko: null,
    poistenie_pzp: null,
    poistenie_fs: null,
    poistenie_olfs_kasko: null,
    variantDebugIndex: null,
    showScoring: false,
    scoringData: null,
    scoringVariant: null,
    zmluvaDialog: false,
    zmluvy: [],
    warningDialog: {
      yesNo: false,
      open: false,
      title: ``,
      text: '',
      action: null,
      hideCancel: false,
      zIndex: 204,
    },
    vybranaZmluva: null,
    loading: {
      open: false,
      utext: '',
      btext: '',
      zIndex: 5,
    },
    //ponuknuteVariantyDialogOpen: false,
    ponuknuteVarianty: [],
    produkty: [],
    selectedVariant: null,
    vybranyPonuknutyVariant: null,
    vybranyPonuknutyVariantError: false,
    poznamka: {
      open: false,
      text: '',
    },
    poznamkaPredmetu: {
      rules: [v => v.length <= 200 || 'Maximálny počet znakov je 200!'],
      message: '',
    },
    historiaPoznamokPredmetu: null,
    poznamkaPredmetuValid: true,
    iur: {
      headers: [],
      items: [],
    },
    deleteDialog: {
      open: false,
      predmet: null,
    },
    menu: [],
    row_variant: false,
    showEmailSpoludlznika: false,
    emailSpoludlznik: null,
    odoslanyEmailSpoludlznik: false,
    suhlasSPodmienkami: false,
    // odoslanyMail: false,
    osobyNaPodisanie: [],
    iban: '',
    ibanError: 0,
    ibanErrorText: '',
    doplnenieIbanDialog: false,
    jeAutomobil: false,
    vin: '',
    vinItem: null,
    vinError: 0,
    vinErrorText: '',
    doplnenieVinDialog: false,
    vins: {
      headers: [
        { text: 'Značka', value: 'brand', class: 'min-w100px' },
        { text: 'Model', value: 'model', class: 'min-w90px' },
        { text: 'Verzia modelu', value: 'nazov', class: 'min-w160px' },
        { text: 'Objem [cm³]', value: 'capacityCcm', class: 'min-w135px' },
        { text: 'Výkon [kW]', value: 'powerKW', class: 'min-w135px' },
        { text: 'Prevodovka ', value: 'gearBoxTypeID', class: 'min-w140px' },
        { text: 'Palivo', value: 'engineTypeID', class: 'min-w120px' },
      ],
      items: [],
    },
    prekalkulovat: false,
    opravneneOsoby: [],
    podpisovanieDokumentov: false,
    doplnenieInformaciiDialog: false,
    doplnujuceInformacie: {
      platcaDph: false,
      ic_dph: '',
      dic: '',
    },
    sposobPodpisania: 1,
    sposobyPodpisania: [
      {
        valueMember: 1,
        displayMember: 'Online v Klientskej zóne',
      },
      {
        valueMember: 2,
        displayMember: 'Osobne na pobočke',
      },
      {
        valueMember: 3,
        displayMember: 'Osobne u sprostredkovateľa',
      },
    ],
    sposobPodpisaniaDialog: false,
    pobocky: [],
    pobocka: null,
    obchodnikEnabled: false,
    obchodnici: [],
    obchodnik: null,
    infoPredmetHeaders: [
      { text: 'VIN', value: 'vyrobne_cislo' },
      { text: 'Dátum prvej registrácie', value: 'dat_reg' },
      { text: 'Počet kilometrov', value: 'pociatocny_stav_km', suffix: ' km' },
      { text: 'Výkon motora', value: 'vykon_motora', suffix: ' kw' },
      { text: 'Objem motora', value: 'objem_motora', suffix: ' cm3' },
      { text: 'Palivo', value: 'palivo' },
    ],
    infoStrojHeaders: [
      { text: 'VIN', value: 'tech_vyrobne_cislo' },
      { text: 'Rok výroby', value: 'tech_rok_vyroby' },
      { text: 'Počet motohodín', value: 'pocet_motohodin' },
      { text: 'Výrobca', value: 'vyrobca' },
      { text: 'Príslušenstvo', value: 'prislusenstvo' },
      { text: 'Krajina pôvodu', value: 'krajina_povodu' },
    ],
    porovnanieBalikovDialog: false,
    porovnanieBalikov: {},
    neplatneDoklady: [],
  }),
  methods: {
    ...mapMutations([
      'setFormControl',
      'deleteFormControl',
      'openDialog',
      'closeDialog',
      'setLoadingDialog',
      'setCanOpenPredmet'
    ]),
    duplikovaniePredmetLoading(open) {
      this.setLoadingDialog({
        open: open,
        btext: 'Prebieha duplikovanie predmetu...',
        utext: 'Proces môže trvať aj niekoľko sekúnd',
      });
    },
    duplikovanieLoading(open) {
      this.setLoadingDialog({
        open: open,
        btext: 'Prebieha duplikovanie zmluvy...',
        utext: 'Proces môže trvať aj niekoľko sekúnd',
      });
    },
    pripravaLoading(open) {
      this.setLoadingDialog({
        open: open,
        btext: 'Prebieha príprava zmluvy...',
        utext: 'Proces môže trvať aj niekoľko sekúnd',
        zIndex: 500,
      });
    },
    prepocetVariantuLoading(open) {
      this.setLoadingDialog({
        open: open,
        btext: 'Prebieha proces prepočítania variantu...',
        utext: 'Proces môže trvať aj niekoľko sekúnd',
      });
      //this.ponuknuteVariantyDialogOpen = !open;
    },
    mazanieLoading(open) {
      this.setLoadingDialog({
        open: open,
        btext: 'Prebieha proces mazania...',
        utext: 'Proces môže trvať aj niekoľko sekúnd',
        zIndex: 500,
      });
    },
    editovaniePredmetu() {
      this.$router.push(`/obchodny-pripad/${this.pripad.newId}?cislo_predmetu=${this.predmet.cislo_predmetu}&step=2`)
    },
    loadingVarianty(open) {
      this.setLoadingDialog({
        open: open,
        btext: 'Prebieha načítavanie...',
        utext: '',
        zIndex: 500,
      });
    },
    odoslatNaSchvalenie() {
      return this.spustiKalkulaciuVariantu(this.selectedVariant)
        .then(async _res => {
          return this.schvalovaniePoPrekalkulovani([this.selectedVariant.cislo_plz]);
        })
        .catch(error => {
          console.error('An error occurred:', error);
        })
        .finally(() => {
          this.nacitajVarianty();
          this.getMenu();
        });
    },
    spustiKalkulaciuVariantu(variant) {
      return protectedAxios
        .post(
          'kalk/variant',
          {
            cisloPlz: variant.cislo_plz,
            newId: this.pripad.newId,
            cisloPredmetu: this.predmet.cislo_predmetu,
            idVariantu: variant.pkid,
          },
          {
            headers: {
              'Content-Type': 'application/json',
            },
          }
        )
        .then(res => {
          if (res.data?.length > 0) eventBus.$emit('snack-error', res.data);
        });
    },
    spustiSchvalenie() {
      return protectedAxios
        .post(
          `sumar/varianty/schvalenie?newId=${this.pripad.newId}&idVariantu=${this.selectedVariant.pkid}`,
          {
            headers: {
              'Content-Type': 'application/json',
            },
          }
        )
        .finally(() => {
          this.reload();
        });
    },

    async nacitajVarianty(showLoading = true) {
      if (showLoading) {
        this.loadingVarianty(true);
      }
      this.selectedVariant = null;
      this.vybranyPonuknutyVariant = null;

      return await protectedAxios
        .get(
          `sumar/varianty?newId=${this.pripad.newId}&cisloPredmetu=${this.predmet.cislo_predmetu}`,
          {
            headers: {
              'Content-Type': 'application/json',
            },
          }
        )
        .then(async res => {
          this.varianty = [];
          this.varianty = await Promise.all(res.data.map(async item => ({
            ...item,
            iur: await this.checkIur(item.cislo_lz, item.pkid),
          })));
          this.$nextTick(() => {
            this.selectedVariant = this.varianty.find(v => v.oznaceny == 1) ?? null;
            if(this.selectedVariant == null){
              console.log('neoznaceny variant',this.varianty.find(v => v.oznaceny == 1));
            }
          });
        })
        .finally(() => {
            this.$forceUpdate();
            if (showLoading) {
              this.loadingVarianty(false);
            }
        })
        .catch(e => {
          console.error(e);
        });
    },
    async nacitajZmluvy() {
      return await protectedAxios
        .get(
          `sumar/zmluvy?newId=${this.pripad.newId}&cisloPredmetu=${this.predmet.cislo_predmetu}`,
          {
            headers: {
              'Content-Type': 'application/json',
            },
          }
        )
        .then(async res => {
          this.zmluvy = await Promise.all(res.data.map(async zmluva => {
            let haveIur = await this.checkIur(zmluva.cislo_lz);
            return { ...zmluva, iur: haveIur || false};
          }));
          if (this.zmluvy.length > 0) {
            await this.nacitajPonuknuteVarianty(this.zmluvy[0].cislo_lz);
            await this.checkSpoludlznika(this.zmluvy[0].cislo_lz);
          }
        })
        .catch(e => {
          console.error(e);
        });
    },
    nacitajPoistenie() {
      return protectedAxios
        .get(
          `sumar/poistenie?newId=${this.pripad.newId}&cisloPredmetu=${this.predmet.cislo_predmetu}`,
          {
            headers: {
              'Content-Type': 'application/json',
            },
          }
        )
        .then(res => {
          if (res.data.length > 0) {
            if (res.data.filter(d => d.typ === 'KASKO').length > 0)
              this.poistenie_kasko = res.data.filter(d => d.typ === 'KASKO')[0];
            if (res.data.filter(d => d.typ === 'PZP').length > 0)
              this.poistenie_pzp = res.data.filter(d => d.typ === 'PZP')[0];
            if (res.data.filter(d => d.typ === 'GAP').length > 0)
              this.poistenie_fs = res.data.filter(d => d.typ === 'GAP')[0];
            if (res.data.filter(d => d.typ === 'OLFS_KASKO').length > 0)
              this.poistenie_olfs_kasko = res.data.filter(d => d.typ === 'OLFS_KASKO')[0];
          }
        })
        .catch(e => {
          console.error(e);
        });
    },
    //debug
    getVariantyDebugEntries() {
      if (this.varianty && this.variantDebugIndex !== null)
        return Object.entries(this.varianty[this.variantDebugIndex]);
      else return [];
    },
    duplikujPredmet(cislOPredmetu) {
      this.duplikovaniePredmetLoading(true);
      protectedAxios
        .post(`pripady/${this.pripad.newId}/predmety/${cislOPredmetu}/clone`, {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then(res => {
          if (res.data.error > 0) {
            eventBus.$emit('snack-error', res.data.errorText ?? "Pri duplikovaní predmetu nastala chyba.");
          }
        })
        .catch(e => {
          console.log(e);
          eventBus.$emit('snack-error', 'Pri duplikovaní predmetu nastala chyba: ' + e);
        })
        .finally(() => {
          this.duplikovaniePredmetLoading(false);
          this.$emit('forceReload');
        });
    },
    openPripravZmluvuDialog(zmluva) {
      this.vybranaZmluva = zmluva;
      // TL to chcelo dat prec pre vsetkych
      // this.warningDialog.yesNo = true;
      // this.warningDialog.title = `Naozaj si prajete pripraviť zmluvu. Nebude možné schváliť iný variant.`;
      // this.warningDialog.text = '';
      // this.warningDialog.action = this.getOpravneneOsoby;
      // this.warningDialog.hideCancel = false;
      // this.warningDialog.open = true;
      // this.warningDialog.zIndex = 204;

      this.getOpravneneOsoby()
    },
    async pripravZmluvu() {
      this.pripravaLoading(true);
      await protectedAxios
        .post(
          `pripady/${this.pripad.newId}/zmluvy/${encodeURIComponent(
            this.vybranaZmluva.cislo_lz
          )}/priprav`
        )
        .then(() => {
          Promise.all([this.nacitajVarianty(), this.nacitajZmluvy(), this.nacitajPoistenie()]);
        })
        .finally(() => this.pripravaLoading(false));
    },

    async pripravZmluvuPobocka() {
      await this.pripravZmluvu();
      await this.pripravZmluvuNextRedirect();
    },

    async pripravZmluvuNextRedirect() {
      await protectedAxios
        .get('/sumar/priprava-zmluvy-pokracovat-redirect')
        .then(res => {
          if (res.data) {
            this.closeDialog();
            if (res.data.startsWith('/')) {
              return this.$router.push(res.data);
            } else {
              window.location.href = res.data;
            }
          }
        })
        .catch(e => console.error(e));
    },

    nacitajProdukty() {
      return protectedAxios
        .get(`/pripady/${this.pripad.newId}/predmety/${this.pripad.cisloPredmetu}/produkty`, {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then(res => {
          this.produkty = res.data;
          Promise.resolve(res.data);
        })
        .catch(e => {
          console.error(e);
          eventBus.$emit('snack-error', 'Pri načítaní produktov nastala chyba.');
        });
    },
    nacitajPonuknuteVarianty(cislo_lz) {
      //this.ponuknuteVariantyLoading(true);
      return protectedAxios
        .get(`sumar/varianty/ponuknute?cisloLZ=${cislo_lz}`, {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then(res => {
          this.ponuknuteVarianty = res.data;
        })
        .catch(e => {
          console.error(e);
          this.vybranyPonuknutyVariantError = true;
          eventBus.$emit('snack-error', 'Pri načítaní ponúknutých variantov nastala chyba.');
        });
    },
    vyberVariant(variant) {
      this.vybranyPonuknutyVariantError = false;
      this.vybranyPonuknutyVariant = variant;
      let akontacia_rozsah = [];
      if (this.predmet.akontacia_rozsah == null) {
        akontacia_rozsah = [-1, -10];
      } else {
        akontacia_rozsah = this.predmet.akontacia_rozsah.split(',').map(akontacia => {
          return parseInt(akontacia);
        });
      }

      let tenor_rozsah = this.predmet.tenor_rozsah.split(',').map(tenor => {
        return parseInt(tenor);
      });
      if (
        this.vybranyPonuknutyVariant.akontacia_perc >= akontacia_rozsah[0] &&
        this.vybranyPonuknutyVariant.akontacia_perc <= akontacia_rozsah[1] &&
        tenor_rozsah.includes(this.vybranyPonuknutyVariant.tenor) &&
        this.vybranyPonuknutyVariant.pkid > -1
      ) {
        this.nastavVariant(this.vybranyPonuknutyVariant).then(() => {
          //this.variantyDialogCloseClick();
          if (!this.vybranyPonuknutyVariantError)
            //this.odoslatNaSchvalenie(this.vybranyPonuknutyVariant);
            this.prepocetVariantuLoading(false);
          this.$emit('odoslatPonuku', this.vybranyPonuknutyVariant);
        });
      } else {
        this.prepocetVariantuLoading(true);
        this.nacitajCache().then(res => {
          if (!this.vybranyPonuknutyVariantError)
            this.nacitajProdukty().then(_res => {
              if (!this.vybranyPonuknutyVariantError) {
                if (this.produkty.length > 0) {
                  let _rozsahy_akontacia = {
                    '40,60': [40, 60],
                    '30,50': [30, 50],
                    '20,40': [20, 40],
                    '10,30': [10, 30],
                    '0,20': [0, 20],
                  };
                  let rozsah_akontacia = Object.keys(_rozsahy_akontacia).find(
                    rozsah =>
                      this.vybranyPonuknutyVariant.akontacia_perc >=
                        _rozsahy_akontacia[rozsah][0] &&
                      this.vybranyPonuknutyVariant.akontacia_perc <= _rozsahy_akontacia[rozsah][1]
                  );
                  let promises = [];
                  if (
                    this.vybranyPonuknutyVariant.akontacia_perc < akontacia_rozsah[0] ||
                    this.vybranyPonuknutyVariant.akontacia_perc > akontacia_rozsah[1]
                  ) {
                    promises.push(
                      this.nastavCachePodlaVariantu(
                        'liw_filip__wiz_kalkulacia__cb_akontacia',
                        rozsah_akontacia
                      )
                    );
                  }
                  if (!tenor_rozsah.includes(this.vybranyPonuknutyVariant.tenor)) {
                    if (tenor_rozsah.length > 2) {
                      let index = 0;
                      let max_tenor = 0;
                      for (let i = 0; i < tenor_rozsah.length; i++) {
                        if (parseInt(tenor_rozsah[i]) > max_tenor) {
                          max_tenor = parseInt(tenor_rozsah[i]);
                          index = i;
                        }
                      }
                      tenor_rozsah.splice(index, 1);
                    }
                    tenor_rozsah.push(this.vybranyPonuknutyVariant.tenor);
                    promises.push(
                      this.nastavCachePodlaVariantu(
                        'liw_filip__wiz_kalkulacia__cb_tenor',
                        tenor_rozsah.join(',')
                      )
                    );
                  }
                  Promise.all(promises).then(async () => {
                    if (!this.vybranyPonuknutyVariantError)
                      return await this.spustiKalkulaciuProduktov().then(async results => {
                        if (!this.vybranyPonuknutyVariantError)
                          return await this.nastavVsetkyVarianty(results).then(async () => {
                            if (!this.vybranyPonuknutyVariantError)
                              return await this.saveObcPripad().then(() => {
                                return this.resetCache().then(_ => {
                                  //this.variantyDialogCloseClick();
                                  this.prepocetVariantuLoading(false);
                                  this.$emit('odoslatPonuku', this.vybranyPonuknutyVariant);
                                });
                              });
                          });
                      });
                  });
                }
              }
            });
        });
      }
    },
    async odoslatPonuku(varianty) {
      return await protectedAxios
        .post('sumar/schvalovanie-filip', {
          newId: this.pripad.newId,
          varianty: varianty.map(variant => ({
            CisloPlz: variant.cislo_plz,
            IdVariantu: variant.pkid,
          })),
        })
        .then(res => {
          let _dialog = {
            persistent: true,
            header: `<span class="f16"> Odoslať na schválenie </span>`,
            closeIcon: {
              value: true,
            },
            text: ``,
          };
          if (res.data.length > 0) {
            if (this.formaPodnikania.pkId == 3) {
              _dialog.text = `<span class="gs100 f16">
                Ponuka bude odoslaná na schválenie po úspešnom prihlásení spolužiadateľa.
              </span>`;
            } else {
              _dialog.text = `<span class="gs100 f16">
                Ponuka bude odoslaná na schválenie po úspešnom prihlásení štatutárov. Jeho priebeh si môžete pozrieť v záložke Dodatočné informácie.
              </span>`;
            }
          } else {
            _dialog.text = `<span class="gs100 f16">
              Ponuka bola úspešne odoslaná na schválenie. O výsledku schvaľovacieho procesu vás
              informujeme e-mailom.
            </span>`;
          }
          this.openDialog(_dialog);
        });
    },
    nastavVariant(variant) {
      if (variant.pkid == null) {
        this.vybranyPonuknutyVariantError = true;
        this.prepocetVariantuLoading(false);
        return Promise.reject('Vybraný variant nemá pkid.');
      }
      return protectedAxios
        .post(
          `kalk/varianty/${variant.pkid}/selected`,
          {
            selected: 1,
            cisloPlz: variant.cislo_plz,
          },
          {
            headers: {
              'Content-Type': 'application/json',
            },
          }
        )
        .catch(e => {
          console.log(e);
          this.vybranyPonuknutyVariantError = true;
          this.prepocetVariantuLoading(false);
          eventBus.$emit('snack-error', 'Pri nastaveni variantu nastala chyba: ' + e);
        });
    },
    nastavVsetkyVarianty(variantyPreProdukty) {
      let promises = [];
      let indexProduktu = variantyPreProdukty.findIndex(_produkt => {
        return _produkt?.data[0]?.cislo_plz === this.vybranyPonuknutyVariant.cislo_plz;
      });

      let variantyPreProdukt = variantyPreProdukty[indexProduktu].data;
      for (let indexVariantu in variantyPreProdukt) {
        let variant = variantyPreProdukt[indexVariantu];
        if (
          variant.akontacia == this.vybranyPonuknutyVariant.akontacia_perc &&
          variant.dlzka_leasingu == this.vybranyPonuknutyVariant.tenor
        ) {
          promises.push(this.nastavVariant(variant));
        }
      }
      return Promise.all(promises);
    },
    nastavCachePodlaVariantu(viewObjectId, value) {
      return protectedAxios
        .post(
          `controls/cache`,
          {
            viewObjectId: viewObjectId,
            cisloPlz: null,
            newId: this.pripad?.newId,
            value: value,
            cisloPredmetu: this.pripad?.cisloPredmetu,
            idZastupcu: null,
          },
          {
            headers: {
              'Content-Type': 'application/json',
            },
          }
        )
        .catch(e => {
          this.vybranyPonuknutyVariantError = true;
          this.prepocetVariantuLoading(false);
          console.error(viewObjectId, e);
          if (e?.onlyInterceptor) return;
          eventBus.$emit('snack-error', 'Chyba pri ukladaní hodnoty.');
        });
    },
    async spustiKalkulaciuProduktov() {
      let promisesKalk = [];
      let promisesPoKalk = [];

      for (let produkt in this.produkty) {
        promisesKalk.push(() => this.spustiKalkulaciuProduktu(this.produkty[produkt]));
        promisesPoKalk.push(() => this.nacitaniePoKalkulacii(this.produkty[produkt]));
      }

      return await Promise.all(
        promisesKalk.map(p =>
          p().catch(e => {
            return Promise.reject(e);
          })
        )
      ).then(async _ => {
        let cislaPlz = [];
        for (let i = 0; i < this.produkty.length; i++) {
          cislaPlz.push(this.produkty[i].cislo_plz);
        }
        return await this.schvalovaniePoPrekalkulovani(cislaPlz).then(async res => {
          return Promise.all(
            promisesPoKalk.map(p =>
              p().catch(e => {
                return Promise.reject(e);
              })
            )
          );
        });
      });
    },
    async spustiKalkulaciuProduktu(produkt) {
      return await protectedAxios
        .post(
          `kalk`,
          {
            cisloPlz: produkt.cislo_plz,
            newId: this.pripad.newId,
            cisloPredmetu: this.pripad.cisloPredmetu,
            idProduktu: produkt.id,
          },
          {
            headers: {
              'Content-Type': 'application/json',
            },
          }
        )
        .then(res => {
          if (res.data?.error_text.length > 0) eventBus.$emit('snack-error', res.data.error_text);
          produkt.cislo_plz = res.data?.cisloPlz;
          return res;
        })
        .catch(e => {
          console.log(e);
          this.vybranyPonuknutyVariantError = true;
          this.prepocetVariantuLoading(false);
          eventBus.$emit('snack-error', 'Pri kalkulácií produktov nastala chyba: ' + e);
        });
    },
    async nacitaniePoKalkulacii(produkt) {
      return await protectedAxios
        .post(
          `kalk/nacianie-po-kalkulacii`,
          {
            cisloPlz: produkt.cislo_plz,
            newId: this.pripad.newId,
            cisloPredmetu: this.pripad.cisloPredmetu,
            idProduktu: produkt.id,
            jeOlfs: produkt.jeOlfs
          },
          {
            headers: {
              'Content-Type': 'application/json',
            },
          }
        )
        .then(res => {
          let index = res.data.findIndex(variant => {
            return (
              variant.akontacia == this.vybranyPonuknutyVariant.akontacia_perc &&
              variant.dlzka_leasingu == this.vybranyPonuknutyVariant.tenor &&
              variant.cislo_plz == this.vybranyPonuknutyVariant.cislo_plz
            );
          });
          if (index > -1) {
            this.vybranyPonuknutyVariant.pkid = res.data[index].pkid;
          }
          return res;
        })
        .catch(e => {
          console.log(e);
          this.vybranyPonuknutyVariantError = true;
          this.prepocetVariantuLoading(false);
          eventBus.$emit('snack-error', 'Pri kalkulácií produktov nastala chyba: ' + e);
        });
    },
    saveObcPripad() {
      return protectedAxios
        .post(
          `pripady/save`,
          {
            newId: this.pripad.newId,
            cisloPredmetu: this.pripad.cisloPredmetu,
            idZastupcu: this.pripad.idZastupcu,
            jeRozpracovany: this.pripad.jeRozpracovany,
          },
          {
            headers: {
              'Content-Type': 'application/json',
            },
          }
        )
        .then(res => {
          return res;
        })
        .catch(e => {
          console.log(e);
          eventBus.$emit('snack-error', 'Pri ukladaní prípadu nastala chyba: ' + e);
        });
    },
    async checkIur(cislo_lz, idVariantu = null) {
      const query = [];
      query.push(`newId=${this.pripad.newId}`);
      query.push(`cisloLz=${cislo_lz}`);
      if(idVariantu != null){
        query.push(`idVariantu=${idVariantu}`);
      }

      return await protectedAxios
        .get(`sumar/iur?${query.join('&')}`, {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then(res => {
          return Array.isArray(res.data) && res.data.length > 1;
        })
        .catch(e => {
          console.error(e);
          return false;
        });
    },
    async nastavPoznamkuAndIur(zmluva,onlyIUR = false) {
      let self = this;
      self.iur.headers = [];
      self.iur.items = [];
      if(zmluva?.cislo_lz || zmluva?.pkid) {
        const query = [];
        query.push(`newId=${this.pripad.newId}`);
        if(zmluva?.cislo_lz){
          query.push(`cisloLz=${zmluva.cislo_lz}`);
        }
        if(zmluva?.pkid != null){
          query.push(`idVariantu=${zmluva.pkid}`);
        }

        return await protectedAxios
        .get(`sumar/iur?${query.join('&')}`, {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then(res => {
          const data = Array.isArray(res.data) ? res.data : [];
          if(data.length === 0)
            return;

          const header = data[0];
          
          for (const key in header) {
            self.iur.headers.push({ text: header[key], value: key, width: '50%' });
          }

          self.iur.items = data.slice(1);
          if(!onlyIUR)
            self.poznamka.text = zmluva.poznamka;
          self.poznamka.open = true;
        })
        .catch(e => {
          console.error(e);
        });
      }else{
        if(!onlyIUR){
          self.poznamka.text = zmluva.poznamka;
          self.poznamka.open = true;
        }
      }
      
    },
    savePoznamkaPredmetu() {
      if (this.$refs.textareaPoznamka.validate() && this.poznamkaPredmetu.message != '') {
        return protectedAxios
          .post(
            `sumar/poznamka`,
            {
              NewId: this.pripad.newId,
              Poznamka: this.poznamkaPredmetu.message,
            },
            {
              headers: {
                'Content-Type': 'application/json',
              },
            }
          )
          .then(res => {
            if (res.data?.error != null) {
              eventBus.$emit(
                'snack-error',
                'Pri ukladaní poznámky nastala chyba: ' + res.data?.error
              );
            }
            this.poznamkaPredmetu.message = '';
            this.nacitajHistoriuPoznamokPredmetu();
            return res;
          })
          .catch(e => {
            console.log(e);
            eventBus.$emit('snack-error', 'Pri ukladaní poznámky nastala chyba: ' + e);
          });
      }
    },
    nacitajHistoriuPoznamokPredmetu() {
      return protectedAxios
        .get(`sumar/historiaPoznamok?newId=${this.pripad.newId}`, {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then(res => {
          this.historiaPoznamokPredmetu = res.data;
        })
        .catch(e => {
          console.error(e);
        });
    },
    openDeleteDialog(predmet) {
      let _dialog = {
        persistent: true,
        header: `<span class="f16"> Odstrániť predmet </span>`,
        closeIcon: {
          value: true,
          func: () => {
            this.deleteDialog.predmet = null;
            this.closeDialog();
          },
        },
        text: `<span class="gs100 f16">
              <span style="font-weight: 700">Upozornenie:</span> Ak odstránite predmet financovania,
              stratíte všetky údaje, ktoré ste doteraz zadali do kalkulačky.
            </span>`,
        primaryBtn: {
          text: 'Odstrániť',
          func: this.deletePredmet,
        },
      };

      this.openDialog(_dialog);
      this.deleteDialog.predmet = predmet;
    },
    async odoslatRegistraciuSpoludlznikovy() {
      if (this.$refs.form.validate()) {
        return await protectedAxios
          .post(`sumar/email-spoludlznika`, {
            NewId: this.pripad.newId,
            Email: this.emailSpoludlznik,
          })
          .then(async res => {
            if(!this.jeDealer){
              let _dialog = {
                header: `<span class="gs100 f16">Odoslať e-mail</span>`,
                closeIcon: {
                  value: true,
                },
                textClass: ['f16'],
                text: `Link na registráciu bol odoslaný na mail
              <span class="white100">
                ${this.emailSpoludlznik}
              </span>
              . Ponuka bude schválená po úspešnom prihlásení spolužiadateľa.`,
                closeBtn: {
                  value: true,
                },
              };
              this.openDialog(_dialog);
            }
            this.$emit('reloadSpoludlznik');
            this.$refs.form.reset();
            this.odoslanyEmailSpoludlznik = true;
            await this.nacitajZmluvy();
            this.$emit('odoslanieEmailuSpoludlznika');
          })
          .catch(e => {
            console.error(e);
          });
      }
    },
    async getOpravneneOsoby() {
      this.pripravaLoading(true);
      await protectedAxios
        .get(
          `sumar/zastupeniNajomcu?newId=${this.pripad.newId}&cisloPlz=${encodeURIComponent(
            this.vybranaZmluva.cislo_plz
          )}`
        )
        .then(async res => {
          this.pripravaLoading(false);
          this.$refs.podpisovanieForm.reset();
          this.opravneneOsoby = res.data.data;
          this.osobyNaPodisanie = [];
          // this.checkVinExist();
          if (this.opravneneOsoby == null || this.opravneneOsoby?.length == 0) {
            eventBus.$emit('snack-error', 'Prípad nemá opravnene osoby.');
          } else {
            if (this.opravneneOsoby?.length > 1) {
              this.osobyNaPodisanie.push(
                ...this.opravneneOsoby
                  .filter(item => item.oznac == -1)
                  ?.map(osoba => {
                    return osoba.id_zastupcu;
                  })
              );
              this.podpisovanieDokumentov = true;
            } else {
              this.osobyNaPodisanie.push(this.opravneneOsoby[0].id_zastupcu);
              this.podpisovanieDokumentov = true;
              await this.$nextTick(async () => {
                await this.podpisatDokumenty();
              });
            }
          }
        })
        .catch(e => {
          console.error(e);
          eventBus.$emit('snack-error', 'Pri načítaní opravnených osôb nastala chyba.');
          this.pripravaLoading(false);
        });
    },
    async podpisatDokumenty() {
      if (this.$refs.podpisovanieForm.validate()) {
        this.podpisovanieDokumentov = false;
        this.pripravaLoading(true);
        return await protectedAxios
          .post('sumar/podpisujuceOsoby', {
            cisloPlz: this.vybranaZmluva.cislo_plz,
            idZakaznika: this.opravneneOsoby[0].id_zakaznika,
            idZastupci: this.osobyNaPodisanie,
          })
          .then(async res => {
            this.pripravaLoading(false);
            await this.checkIbanExist();
          })
          .catch(e => {
            console.error(e);
            eventBus.$emit('snack-error', 'Pri ukladaní podpisujúcich osôb nastala chyba.');
            this.pripravaLoading(false);
          });
      }
    },
    async checkIbanExist() {
      return await protectedAxios
        .get(
          `sumar/checkVyplnenyIban?newId=${this.pripad.newId}&cisloPredmetu=${this.predmet.cislo_predmetu}
      `
        )
        .then(async res => {
          this.pripravaLoading(false);
          this.iban = "";
          if (res.data == 1) {
            await this.checkVinExist();
          } else {
            this.ibanError = 0;
            this.ibanErrorText = '';
            this.$refs.checkIbanForm.reset();
            this.doplnenieIbanDialog = true;
          }
        })
        .catch(e => {
          console.error(e);
          eventBus.$emit('snack-error', 'Pri zisťovaní IBAN nastala chyba.');
          this.pripravaLoading(false);
        });
    },
    async checkCorrectnessIban(value){
      this.ibanError = 0;
      this.ibanErrorText = '';
      if(value == null || value == ""){
        return;
      }
      return await protectedAxios.get(`pripady/checkCorrectnessIban?iban=${value}`).then(res => {
        if(!res.data.error){
          this.iban = res.data.iban;
        }else{
          this.ibanError = 100;
          this.ibanErrorText = "IBAN má nesprávny formát";
        }
      })
    },
    async aktualizovatIban() {
      if (this.$refs.checkIbanForm.validate()) {
        await this.checkCorrectnessIban(this.iban).then(async ()=>{
          if(this.ibanError == 0){
            this.pripravaLoading(true);
            await protectedAxios
              .post('sumar/updateIban', {
                newId: this.pripad.newId,
                iban: this.iban,
              })
              .then(async res => {
                this.pripravaLoading(false);
                this.ibanError = res.data.error;
                this.ibanErrorText = res.data.error_text;
                  if(this.ibanError == 0){
                    this.doplnenieIbanDialog = false;
                    this.pripravaLoading(true);
                    await this.checkVinExist();
                  }
              })
              .catch(e => {
                console.error(e);
                eventBus.$emit('snack-error', 'Pri kontrole IBAN nastala chyba.');
                this.doplnenieIbanDialog = false;
                this.pripravaLoading(false);
              });
          }
        })
      }
    },
    async checkVinExist() {
      return await protectedAxios
        .get(
          `sumar/checkVyplneneVIN?newId=${this.pripad.newId}&cisloPredmetu=${this.predmet.cislo_predmetu}
      `
        )
        .then(async res => {
          this.pripravaLoading(false);
          if (res.data) {
            this.jeAutomobil = res.data.jeAuto ? true : false;
            this.vin = res.data.vyrobneCislo;
            if (this.vin != null && this.vin != '') {
              if (this.shouldOpenDoplnenieInformaciiDialog()) {
                await this.getIc();
              } else {
                this.sposobPodpisaniaDialog = true;
              }
            } else {
              this.vinError = 0;
              this.vinErrorText = '';
              this.prekalkulovat = false;
              this.$refs.checkVinForm.reset();
              this.doplnenieVinDialog = true;
            }
          }
        })
        .catch(e => {
          console.error(e);
          eventBus.$emit('snack-error', 'Pri zisťovaní výrobného čísla nastala chyba.');
          this.pripravaLoading(false);
        });
    },
    async aktualizovatVin() {
      if (this.$refs.checkVinForm.validate()) {
        this.vinError = 0;
        this.vinErrorText = '';
        this.prekalkulovat = false;
        this.pripravaLoading(true);
        if (this.jeAutomobil) {
          await protectedAxios
            .get(
              `/pripady/${this.pripad.newId}/predmety/${
                this.predmet.cislo_predmetu
              }/check-vin-car-catalog?vin=${this.vin}&cisloLz=${encodeURIComponent(
                this.vybranaZmluva.cislo_lz
              )}&noCache=true`
            )
            .then(async res => {
              this.pripravaLoading(false);
              this.warningDialog.yesNo = false;
              this.warningDialog.hideCancel = true;
              this.warningDialog.title = '';
              this.warningDialog.action = null;
              this.warningDialog.zIndex = 550;
              let result = true;
              if (res.data.vinCheck.error < 1000) {
                result = true;
                // TMAH351DGPJ205744
              } else if (res.data.vinCheck.error >= 1000 && res.data.vinCheck.error < 2000) {
                // vin: VF34C5FS0AS319043
                this.vins.items = res.data.vins;
                this.warningDialog.title = res.data.vinCheck.errorText;
                result = false;
                this.warningDialog.open = true;
              } else if (res.data.vinCheck.error >= 2000) {
                // TODO ak bude 2002 tak moze zmenit vin ale v tom pripade musi prebehnut kontrola ktora je cez tlacitko pokracovat
                // vin: TMBHS21Z982232201
                this.vinItem = res.data.vins[0];
                this.vinError = res.data.vinCheck.error;
                this.vinErrorText = res.data.vinCheck.errorText;
                result = false;
              }
              if (!result) {
                if (this.vinError != 2001) this.prekalkulovat = true;
              } else {
                if (this.shouldOpenDoplnenieInformaciiDialog()) {
                  await this.getIc();
                } else {
                  this.sposobPodpisaniaDialog = true;
                }
                this.doplnenieVinDialog = false;
              }
            })
            .catch(e => {
              console.error(e);
              eventBus.$emit('snack-error', 'Pri kontrolovaní výrobného čísla nastala chyba.');
              this.doplnenieVinDialog = false;
              this.pripravaLoading(false);
            });
        } else {
          await protectedAxios
            .post(`sumar/updateTechVyrobneCislo`, {
              newId: this.pripad.newId,
              cisloPredmetu: this.predmet.cislo_predmetu,
              cisloPlz: this.vybranaZmluva.cislo_plz,
              vyrobneCislo: this.vin,
            })
            .then(async () => {
              this.pripravaLoading(false);
              if (this.shouldOpenDoplnenieInformaciiDialog()) {
                await this.getIc();
              } else {
                this.sposobPodpisaniaDialog = true;
              }
              this.doplnenieVinDialog = false;
            })
            .catch(e => {
              console.error(e);
              eventBus.$emit('snack-error', 'Pri ukladaní výrobného čísla nastala chyba.');
              this.pripravaLoading(false);
            });
        }
      }
    },
    async selectVerziaModelu(item) {
      this.pripravaLoading(true);
      await protectedAxios
        .get(
          `sumar/checkCarCatalogVerzia?newId=${this.pripad.newId}&cisloPredmetu=${
            this.predmet.cislo_predmetu
          }&idVerzieModelu=${encodeURIComponent(item.vehicleID)}&idZnacky=${
            item.id_znacky
          }&idModelu=${item.id_modelu}&cennikovaCena=${item.priceWithVat}`
        )
        .then(async res => {
          this.vins.items = [];
          this.pripravaLoading(false);
          this.vinError = res.data.error;
          this.vinErrorText = res.data.error_text;
          this.vinItem = item;
          if(this.vinError == 0){
            await protectedAxios.post(`sumar/updateCarCatalogVIN`,{
              new_id: this.pripad.newId,
              cislo_predmetu: this.predmet.cislo_predmetu,
              cislo_lz: this.vybranaZmluva.cislo_lz,
              vin: this.vin,
              catalogSumarModel: this.vinItem,
            }).then(async _ => {
              if (this.shouldOpenDoplnenieInformaciiDialog()) {
                  await this.getIc();
                } else {
                  this.sposobPodpisaniaDialog = true;
                }
                this.doplnenieVinDialog = false;
            })
          }
        })
        .catch(e => {
          console.error(e);
          eventBus.$emit('snack-error', 'Pri kontrolovaní výrobného čísla nastala chyba.');
          this.pripravaLoading(false);
        });
    },
    async prekalkulovatPonuku() {
      this.pripravaLoading(true);
      await protectedAxios
        .post(`sumar/updateCarCatalog`, {
          new_id: this.pripad.newId,
          cislo_predmetu: this.predmet.cislo_predmetu,
          cislo_lz: this.vybranaZmluva.cislo_lz,
          vin: this.vin,
          error: this.vinError,
          catalogSumarModel: this.vinItem,
        })
        .then(res => {
          this.pripravaLoading(false);
          this.$router.push(
            '/obchodny-pripad/' +
              this.pripad.newId +
              '?cislo_predmetu=' +
              this.predmet.cislo_predmetu +
              '&redirect=2'
          );
        })
        .catch(e => {
          console.error(e);
          eventBus.$emit('snack-error', 'Pri ukladaní dát pre prekalkulovanie nastala chyba.');
          this.pripravaLoading(false);
        });
    },
    async getIc() {
      this.pripravaLoading(true);
      await protectedAxios.get(`sumar/icDph?newId=${this.pripad.newId}`).then(res => {
        this.doplnujuceInformacie.ic_dph = res.data.ic_dph;
        this.doplnujuceInformacie.dic = res.data.dic;
        this.doplnujuceInformacie.platcaDph = typeof res.data.je_platcom_dph === "boolean" ? res.data.je_platcom_dph : res.data.je_platcom_dph === 1;
        this.doplnenieInformaciiDialog = true;
        this.pripravaLoading(false);
      });
    },
    shouldOpenDoplnenieInformaciiDialog() {
      const isPodnikatel =
        this.formaPodnikania?.pkId == 1 || this.formaPodnikania?.pkId == 2;
      const firstRoleId = Number(this.$store.getters['auth/user']?.role?.[0]);

      return (
        isPodnikatel &&
        (
          !this.jeDealer ||
          firstRoleId === 1 ||
          firstRoleId === 4
        )
      );
    },
    async setIc() {
      if (this.$refs.doplnujuceInformacieForm.validate()) {
        this.pripravaLoading(true);
        await protectedAxios
          .post(`sumar/updateIcDph`, {
            newId: this.pripad.newId,
            icDph: this.doplnujuceInformacie.ic_dph,
            dic: this.doplnujuceInformacie.dic,
            jePlatcomDph: this.doplnujuceInformacie.platcaDph ? 1 : 0,
          })
          .then(res => {
            this.doplnenieInformaciiDialog = false;
            this.sposobPodpisaniaDialog = true;
            this.pripravaLoading(false);
          })
          .catch(e => {
            console.error(e);
            eventBus.$emit('snack-error', 'Pri ukladaní dát nastala chyba.');
            this.pripravaLoading(false);
          });
      }
    },
    async getZoznamPobociek() {
      await protectedAxios.get(`sumar/zoznamPobociek`).then(res => {
        this.pobocka = null;
        this.pobocky = res.data;
      });
    },
    async getZoznamObchodnikov(item) {
      await protectedAxios
        .get(`sumar/zoznamObchodnikov?idPobocky=${item.id_pobocky_podpis}`)
        .then(res => {
          this.obchodnik = null;
          this.obchodnici = res.data;
          this.obchodnikEnabled = true;
        });
    },
    async setSposobPodpisu() {
      if (this.sposobPodpisania == 2) {
        if (this.$refs.vyberPobocky.validate()) {
          this.pripravaLoading(true);
          await protectedAxios
            .post(`sumar/setSposobPodpisuZmluvy`, {
              sposobPodpisu: this.sposobPodpisania,
              cisloPlz: this.vybranaZmluva.cislo_plz,
              idPobocky: this.pobocka.id_pobocky_podpis,
              idOperator: this.obchodnik?.id_operatora_podpis,
            })
            .then(async res => {
              this.sposobPodpisaniaDialog = false;
              this.pripravaLoading(false);
              await this.verifikaciaOp();
            })
            .catch(e => {
              console.error(e);
              eventBus.$emit('snack-error', 'Pri ukladaní dát nastala chyba.');
              this.pripravaLoading(false);
            });
        }
      } else {
        this.pripravaLoading(true);
        await protectedAxios
          .post(`sumar/setSposobPodpisuZmluvy`, {
            sposobPodpisu: this.sposobPodpisania,
            cisloPlz: this.vybranaZmluva.cislo_plz,
            idPobocky: null,
            idOperator: null,
          })
          .then(async res => {
            this.sposobPodpisaniaDialog = false;
            this.pripravaLoading(false);
            if(this.sposobPodpisania == 1){
              await this.pripravZmluvu();
              await this.pripravZmluvuNextRedirect();
            }else{
              await this.verifikaciaOp();
            }
          })
          .catch(e => {
            console.error(e);
            eventBus.$emit('snack-error', 'Pri ukladaní dát nastala chyba.');
            this.pripravaLoading(false);
          });
      }
    },
    async verifikaciaOp(){
      this.neplatneDoklady = [];
      this.pripravaLoading(true);
      await protectedAxios
        .post(`sumar/podpisZmluvyVerifikaciaOp`, {
          SposobPodpisu: this.sposobPodpisania,
          CisloPlz: this.vybranaZmluva.cislo_plz,
        })
        .then(async res => {
          console.log(res);
          this.pripravaLoading(false);
          let valid = res.data.valid;
          let idDetail = res.data.idDetail;
          let errorText = res.data.errorText;
          this.neplatneDoklady = res.data.errorDetailValues;

          if(valid == true || idDetail == 120){
            await this.infoOSposobePodpisu();
          }else if ((valid == false || idDetail == 130) && this.jeDealer){
            let text = errorText;
            let _dialog = null;
              _dialog = {
              header: `<span class="gs100 f16">Overenie dokladu</span>`,
              text: text,
              primaryBtn: {
                text: 'Áno',
                func: ()=>{
                  this.$router.push(`/obchodny-pripad/${this.pripad.newId}/najomca`);
                  this.closeDialog();
                },
              },
              secondaryBtn: {
                text: 'Nie',
                func: async () => {
                  this.closeDialog();
                  await this.chybajuceDoklady();
                },
              },
            };         
            this.openDialog(_dialog);
          }else{
            let text = errorText;
            let _dialog = {
              header: `<span class="gs100 f16">Overenie dokladu</span>`,
              text: text,
              primaryBtn: {
                text: 'OK',
                func: ()=>{
                  this.closeDialog();
                },
              },
            };
            this.openDialog(_dialog);
          }
        })
        .catch(e => {
          console.error(e);
          eventBus.$emit('snack-error', 'Pri verifikácii nastala chyba.');
          this.pripravaLoading(false);
        });
    },
    async chybajuceDoklady(){
      this.pripravaLoading(true);
      await protectedAxios
        .post(`sumar/chybajuceDoklady`, {
          osoby: this.neplatneDoklady,
          cisloLz: this.vybranaZmluva.cislo_lz,
          newId: this.pripad.newId
        })
        .then(async res => {
          this.pripravaLoading(false);
          await this.infoOSposobePodpisu()
        });
    },
    async infoOSposobePodpisu(){
      if (this.sposobPodpisania == 2) {
        let text = `Pobočka 
        <span class="white100">
          ${this.pobocka.adresa}
        </span>`;
        if (this.obchodnik != null) {
          text += ` a obchodník 
          <span class="white100">
            ${this.obchodnik.meno}
          </span>
          boli úspešne vybrané.`;
        } else {
          text += ` bola úspešne vybraná.`;
        }
        text += ` Pracovník pobočky vás bude kontaktovať čo najskôr v pracovných dňoch medzi 9:00 - 17:00.`;
        let _dialog = {
          header: `<span class="gs100 f16">Pripraviť zmluvu</span>`,
          closeIcon: {
            value: true,
          },
          textClass: ['f16'],
          text: text,
          primaryBtn: {
            text: 'Pokračovať',
            func: this.pripravZmluvuPobocka,
          },
          secondaryBtn: {
            text: 'Zmeniť pobočku',
            func: () => {
              this.sposobPodpisaniaDialog = true;
              this.closeDialog();
            },
          },
        };
        this.openDialog(_dialog);
      } else {
        await this.pripravZmluvu();
        await this.pripravZmluvuNextRedirect();
      }
    },
    openTechcar(zmluva) {
      console.log('presmerovanie na techcar', zmluva);
    },
    async deletePredmet() {
      this.mazanieLoading(true);
      await protectedAxios
        .post(`/pripady/${this.pripad.newId}/predmety/${this.deleteDialog.predmet}/zmazat`, {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then(async res => {
          if (res.data.error) {
            eventBus.$emit(
              'snack-error',
              'Pri mazaní predmetu nastala chyba: ' + res.data.errorText
            );
          } else {
            if (res.data.cisloObchPripadu) {
              this.getMenu();
            } else {
              await this.getRedirect();
            }
          }
        })
        .catch(e => {
          console.error(e);
        })
        .finally(() => {
          this.closeDialog();
          this.mazanieLoading(false);
          this.$emit('forceReload');
        });
    },
    async getRedirect() {
      if (this.jeDealer) {
        return this.$router.push('/');
      } else {
        await protectedAxios
          .get(`/login/action-redirect`, {
            headers: {
              'Content-Type': 'application/json',
            },
            params: {
              step: -1, //novy obch pripad s naplnenim info o profile alebo redirect na /nove-financovanie
            },
          })
          .then(res => {
            if (res.data != null) {
              window.open(res.data, '_self');
            } else {
              console.log('Nie je url redirect');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }
    },
    getMenu() {
      protectedAxios
        .get(`/pripady/${this.pripad.newId}/predmety/${this.predmet.cislo_predmetu}/menu/1`, {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then(res => {
          (this.menu = res.data);
          if(this.show){
            this.setCanOpenPredmet(this.getMenuItem('edit')?.is_enabled && this.getMenuItem('edit')?.is_visible)
          }
        });
    },
    getMenuItem(valueMember) {
      let menufiltered = this.menu.filter(m => m.value_member === valueMember);
      if (menufiltered.length > 0) {
        return menufiltered[0];
      }
      return {};
    },
    async selectVariant(val) {
      for (let i = 0; i < this.varianty.length; i++) {
        if (this.varianty[i].pkid == val.pkid || this.varianty[i].oznaceny == 1) {
          await protectedAxios
            .post(
              `sumar/varianty/${this.varianty[i].pkid}/selected`,
              {
                selected: this.varianty[i].oznaceny ? 0 : 1,
                cisloPlz: this.varianty[i].cislo_plz,
              },
              {
                headers: {
                  'Content-Type': 'application/json',
                },
              }
            )
            .then(() => {})
            .catch(e => {
              console.error(e);
              eventBus.$emit('snack-error', 'Variant sa nepodarilo označiť');
            });
        }
      }
      await this.nacitajOznaceniaVariantov();
    },
    nacitajOznaceniaVariantov() {
      this.selectedVariant = null;
      this.vybranyPonuknutyVariant = null;

      return protectedAxios
        .get(
          `sumar/varianty/selected?newId=${this.pripad.newId}&cisloPredmetu=${this.predmet.cislo_predmetu}`,
          {
            headers: {
              'Content-Type': 'application/json',
            },
          }
        )
        .then(res => {
          const status = res.data.reduce((acc, variant) => {
            acc[variant.id_variantu] = {
              odoslany_na_schvalenie: variant.odoslany_na_schvalenie,
              oznaceny: variant.oznaceny,
            };
            return acc;
          }, {});
          for (let i = 0; i < this.varianty.length; i++) {
            if (status[this.varianty[i].pkid] != null) {
              this.varianty[i].odoslany_na_schvalenie =
                status[this.varianty[i].pkid].odoslany_na_schvalenie;
              this.varianty[i].oznaceny = status[this.varianty[i].pkid].oznaceny;
            }
          }
          this.selectedVariant = this.varianty.find(v => v.oznaceny == 1) ?? null;
          this.$nextTick(() => {
            this.$forceUpdate();
          });
        })
        .catch(e => {
          console.error(e);
        });
    },
    async checkSpoludlznika(cislo_lz) {
      return await protectedAxios
        .get(`sumar/check-spoludlznika?cisloLZ=${cislo_lz}`, {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then(async res => {
          if (res.data.length > 0) {
            return await this.getEmailSpoludlznika();
          } else {
            this.showEmailSpoludlznika = false;
          }
        })
        .catch(e => {
          console.error(e);
        });
    },
    async getEmailSpoludlznika() {
      return await protectedAxios
        .get(`sumar/email-spoludlznika?newId=${this.pripad.newId}`, {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then(res => {
          this.showEmailSpoludlznika = true;
          this.odoslanyEmailSpoludlznik = false;
          if (res.data.length > 0) {
            this.emailSpoludlznik = res.data[0];
            this.odoslanyEmailSpoludlznik = true;
          }
        })
        .catch(e => {
          console.error(e);
        });
    },
    openSuhlasDialog(zmluva) {
      let text = `<span class="f16 bold white100">Vami zvolená ponuka môže byť pripravená po splnení nasledujúcich podmienok:<br/><br/></span>`
      if(zmluva.poznamka != null && zmluva.poznamka != ""){
        text += `<span class="f16">${zmluva.poznamka}</span>`;
        if(zmluva.poznamka_2 != null && zmluva.poznamka_2 != "")
          text += `<br/><br/>`;
      }
      if(zmluva.poznamka_2 != null && zmluva.poznamka_2 != ""){
        text += `<span class="f16">${zmluva.poznamka_2}</span>`;
      }
                  
      let dialog = {
        persistent: true,
        header: `<span class="gs100 f16">Podmienky financovania</span>`,
        text: text,
        closeIcon: {
          value: true,
        },
        primaryBtn: {
          text: `Oboznámil/a som sa a súhlasím`,
          func: () => this.suhlasVariantu(zmluva),
          disabled: zmluva.suhlas_poznamka == 1 ? true : false,
        },
        closeBtn: {
          value: true,
          text: 'Nesúhlasím',
          disabled: zmluva.suhlas_poznamka == 1 ? true : false,
        },
      };

      this.openDialog(dialog);
    },
    async suhlasVariantu(value) {
      return await protectedAxios
        .post(`sumar/SuhlasVariantu`, {
          NewId: this.pripad.newId,
          IdIur: value.id_iur,
          PkIdLsd: value.pkid_lsd,
          PkIdLsv: null,
          poznamka2: value.poznamka_2,
          cisloPredmetu: value.cislo_predmetu,
          cisloLZ: value.cislo_lz,
        })
        .catch(e => {
          console.error(e);
        })
        .finally(() => {
          this.nacitajZmluvy();
          this.closeDialog();
        });
    },
    async reload() {
      this.nacitajVarianty();
      this.nacitajZmluvy();
      this.getMenu();
    },
    async reloadSpoludlznik(){
      if(this.zmluvy.length > 0)
      await this.checkSpoludlznika(this.zmluvy[0].cislo_lz);
    },
    onChangePlatcaDPH(val){
      if(!val){
        this.doplnujuceInformacie.ic_dph = '';
      }
    },
    required: value => {
      return !!value || value === 0 || 'Povinné pole';
    },
    podpisovanie: value => {
      return value?.length > 0 || 'Vyberte aspoň jednu osobu!';
    },
    vinRule(v) {
      if (this.jeAutomobil) {
        if (v?.length > 0 && v?.length != 17) return 'VIN musí obsahovať 17 znakov.';
        if (!/^[a-hj-npr-zA-HJ-NPR-Z0-9]*$/.test(v)) return 'Nesprávny formát VIN.';
      }else{
        if (v?.length > 0 && v?.length > 30) return 'VIN musí obsahovať maximálne 30 znakov.';
      }
      return true;
    },
    email(v) {
      if (!v) return true;
      if (
        //podla RFC 5322
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
          v
        )
      )
        return true;
      else return 'Nesprávny formát e-mailovej adresy';
    },
    kontrolaPovinnostiSpoludlznika(){
      if(this.showEmailSpoludlznika){
        return this.$refs['form'].validate() && this.odoslanyEmailSpoludlznik
      }else{
        return true;
      }
    },
    async openPorovnanieBalikovDialog(){
      await protectedAxios
        .get(`/pripady/${this.pripad.newId}/olfs-porovnanie-balikov/${this.pripad.cisloPredmetu}/1`)
        .then(res =>{
          if(res != null){
            this.porovnanieBalikov = res.data.reduce((obj, item) => {
              (obj[item.value_member] ||= []).push(item);
              return obj;
            }, {});
            this.porovnanieBalikovDialog = true;
          }
        });
    },
    closePorovnanieBalikov(){
      this.porovnanieBalikovDialog = false;
      this.porovnanieBalikov = {};
    },
  },
  created() {
    this.isLoaded = false;
    this.selectedVariant = null;
    Promise.all([
      this.getMenu(),
      // Parent PripadyWizardSumar.reload() drzi globalny loading pre cely sumar.
      // Pri inicialnom vytvoreni predmetov ho child komponent nesmie zavriet skor,
      // nez su nacitane vsetky predmety.
      this.nacitajVarianty(false),
      this.nacitajZmluvy(),
      this.nacitajPoistenie(),
    ]).then(() => {
      this.nacitajHistoriuPoznamokPredmetu();
      this.isLoaded = true;
      if (this.odoslatNaSchvalenieRequest?.varianty?.length > 0) {
        if (this.varianty.length > 0) {
          this.selectedVariant = this.varianty.find(v => {
            return this.odoslatNaSchvalenieRequest.varianty.some(v2 => v2.pkid == v.pkid);
          });
        }
      }
    });
  },
};
</script>
<style lang="sass">
.sumar-zmluva-card
  border: 1px white solid !important

.sumar-predmet-check-icon
  color: #0097FD !important

.debug-card
  position: fixed !important
  top: 150px
  left: 0
  overflow: scroll
  z-index: 1
  &:hover
    z-index: 5


  th
    text-align: right
</style>
